import API, { initApiUrl } from '@/store/api'
import { ofOrderDetail } from '@/models/MyOrder/OrderDetail'
import ResultSet from '@/models/Common/ResultSet'
import { ofChatbot } from '@/models/Chatbot'

initApiUrl('')

const myOrderHistoryDetailV2 = {
  namespaced: true,
  state: {
    orderDetail: ofOrderDetail(),
    customerServiceTelephoneNumber: '1600-0025',
    cashReceipt: [],
    chatbot: ofChatbot()
  },
  mutations: {
    setOrderDetail(state, payload) {
      state.orderDetail = payload
    },
    setCashReceipt(state, payload) {
      state.cashReceipt = payload
    },
    setChatbotStatus: (state, payload) => {
      state.chatbot = ofChatbot(payload)
    }
  },
  getters: {
    orderDetail: (state) => state.orderDetail,
    customerServiceTelephoneNumber: (state) => state.customerServiceTelephoneNumber,
    cashReceipt: (state) => state.cashReceipt,
    chatbotStatus: (state) => state.chatbot
  },
  actions: {
    loadOrderDetail: async ({ commit, rootState }, { orderId }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key,
          'SESSION-ID': rootState.user.authorization.sessionId,
          Authorization: `Bearer ${rootState.user.authorization.accessToken}`
        }
      }

      const { failed, message, result, code, errorCode } = await API.get(`/v1/orders/${orderId}`, option)
      if (code !== '200') return ResultSet.fail({ message, code, result, errorCode })
      if (failed) return ResultSet.fail({ message, code, result, errorCode })

      commit('setOrderDetail', ofOrderDetail(result))

      return ResultSet.ok({ message, result })
    },

    loadCashReceipt: async ({ commit }, orderNumber) => {
      const { failed, message, result, errorCode } = await API.get(`v1/payment/approval/receipt/cash/${orderNumber}`)

      if (failed) return ResultSet.fail({ message, errorCode })

      commit('setCashReceipt', result.receipts)

      return ResultSet.ok({ result })
    },

    deleteOrder: async ({ rootState }, { orderId }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key,
          'SESSION-ID': rootState.user.authorization.sessionId,
          Authorization: `Bearer ${rootState.user.authorization.accessToken}`
        }
      }

      const { failed, message, result, code, errorCode } = await API.delete(`/v1/orders/${orderId}`, option)
      if (code !== '200') return ResultSet.fail({ message, code, result, errorCode })
      if (failed) return ResultSet.fail({ message, code, result, errorCode })

      return ResultSet.ok({ result, message })
    },

    checkServiceArea: async ({ rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const result = await API.get('/v1/main/shop', option)

      if (result.code !== '200') return ResultSet.fail(result)
      if (result.failed) return ResultSet.fail(result)

      return ResultSet.ok({ result: result.result, message: result.message })
    },

    loadChatbot: async ({ commit, rootState }) => {
      try {
        const option = {
          headers: {
            'user-baedal': rootState.user.authorization.key
          }
        }

        const { failed, result, message, code, errorCode } = await API.get(
          `/v1/chatbot/service/status?orderTime=${rootState.myOrderHistoryDetailV2.orderDetail.summary.arriveDateTime.replace(
            'T',
            '%20'
          )}`,
          option
        )
        if (failed) return ResultSet.fail({ message, code, result, errorCode })

        commit('setChatbotStatus', result)

        return ResultSet.ok({ result, message })
      } catch (error) {
        return error.response.data.result
      }
    }
  }
}

export default myOrderHistoryDetailV2
